
import { defineComponent, ref } from 'vue'
import { store } from '@/store'
import PrivacyPage from '@/views/pages/Privacy.vue'

export default defineComponent({
  props: {
    routeId: String
  },
  components: { PrivacyPage },
  name: 'PrivacyConsent',
  setup() {

    const showMore = ref(false)

    function accept() {
      store.user.acceptPrivacy()
      store.modal.hideModal('PrivacyConsent')
    }
    
    return { accept, showMore }
  }
})
